import "core-js/modules/es6.function.name";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.regexp.replace";
import _regeneratorRuntime from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCustomerList } from '@/views/cardSystem/customer/api/index';
import { createProjectDelivery, getProjectDeliveryDetail, launchedAgain, auditProjectDelivery, getProjectDeliveryLog } from "../api";
export default {
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add'
    }
  },
  data: function data() {
    var _this = this;
    return {
      activeTab: '1',
      companyList: [],
      userList: [],
      approveDialogVisible: false,
      approveFormData: {
        audit: 1,
        group: null,
        person_charge_id: null,
        reason: ''
      },
      approveRules: {
        group: [{
          required: true,
          message: '请选择是否拉群',
          trigger: 'change'
        }],
        person_charge_id: [{
          required: true,
          message: '请选择项目负责人',
          trigger: 'change'
        }]
      },
      rejectDialogVisible: false,
      rejectFormData: {
        audit: 0,
        reason: ''
      },
      rejectRules: {
        reason: [{
          required: true,
          message: '请输入驳回原因',
          trigger: 'blur'
        }]
      },
      rules: {
        customer_id: [{
          required: true,
          message: '请选择客户',
          trigger: 'change'
        }],
        type: [{
          required: true,
          type: 'array',
          min: 1,
          message: '请选择需求类型',
          trigger: 'change'
        }],
        'items.mall_decoration.scene': [{
          required: true,
          message: '请选择使用场景',
          trigger: 'change'
        }],
        'items.mall_decoration.deliveryTime': [{
          required: true,
          message: '请选择交付时间',
          trigger: 'change'
        }],
        'items.mall_decoration.budget': [{
          required: true,
          message: '请输入预算金额',
          trigger: ['blur', 'change']
        }, {
          validator: function validator(rule, value, callback) {
            if (value === '' || value === null || value === undefined) return callback(new Error('请输入预算金额'));
            var v = String(value);
            var reg = /^\d{1,9}(?:\.\d{1,2})?$/;
            if (!reg.test(v)) {
              return callback(new Error('预算金额最多9位整数和2位小数'));
            }
            callback();
          },
          trigger: ['blur', 'change']
        }],
        'items.mall_decoration.mallName': [{
          required: true,
          message: '请输入商城名称',
          trigger: ['blur', 'change']
        }],
        'items.mall_decoration.banner': [{
          required: true,
          message: '请选择客户Banner',
          trigger: 'change'
        }],
        'items.mall_decoration.modules': [{
          required: true,
          type: 'array',
          min: 1,
          message: '请选择至少一个功能板块',
          trigger: 'change'
        }],
        'items.mall_decoration.packageId': [{
          required: true,
          message: '请输入礼包方案ID',
          trigger: ['blur', 'change']
        }],
        'items.mall_decoration.hasDiscount': [{
          validator: function validator(rule, value, callback) {
            if (_this.formData.items.mall_decoration.modules.includes('4')) {
              if (value === '' || value === null || value === undefined) {
                return callback(new Error('请选择商品是否有折扣'));
              }
            }
            callback();
          },
          trigger: 'change'
        }],
        'items.mall_decoration.discount': [{
          validator: function validator(rule, value, callback) {
            if (_this.formData.items.mall_decoration.modules.includes('4') && _this.formData.items.mall_decoration.hasDiscount === '1') {
              if (value === '' || value === null || value === undefined) {
                return callback(new Error('请输入商城商品折扣'));
              }
            }
            callback();
          },
          trigger: ['blur', 'change']
        }],
        'items.mall_decoration.remark': [{
          type: 'string',
          max: 500,
          message: '最多500个字符',
          trigger: 'blur'
        }]
      },
      // mall_decoration 商城装修
      // bidding_support 招投标支持
      // card_and_coupon_design 卡券设计(印刷)
      // special_approval_sales_discounts 销售折扣特批
      // business_support 商务支持
      // union_implementation 智慧工会实施
      // card_rule_adjustments 卡规则调整(含商品打折)
      // trade_union_activities 工会活动
      formData: {
        customer_id: '',
        create_name: '',
        organize_name: '',
        type: [],
        items: {
          mall_decoration: {
            scene: '',
            //1下单使用 2演示使用
            deliveryTime: '',
            //装修交付时间
            budget: '',
            //预算金额
            mallName: '首页',
            //商城名称
            banner: '',
            //1更换 2不更换
            modules: [],
            //功能板块 1电影 2生日 3礼包 4商城 5其他
            packageId: '',
            //礼包方案ID
            hasDiscount: '',
            //商品是否有折扣 1是 0否
            discount: '',
            //商城商品折扣
            remark: '' //其他说明
          }
        }
      },
      logSearchForm: {
        id: this.id,
        pageSize: 20,
        page: 1
      },
      logList: [],
      logPages: {
        currentPage: 1,
        totalCount: 0
      }
    };
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.getCompanyList();
          case 2:
            if (!_this2.id) {
              _this2.formData.create_name = _this2.$store.state.user.userInfo.nick_name;
            } else {
              _this2.viewDetail();
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    inputName: function inputName() {
      return this.formData.create_name + (this.formData.organize_name ? '/' + this.formData.organize_name : '');
    }
  },
  methods: {
    close: function close() {
      this.$emit('update:visible', false);
    },
    handleBudgetInput: function handleBudgetInput(value) {
      var raw = String(value || '');
      var cleaned = raw.replace(/[^\d.]/g, '');
      var dotIndex = cleaned.indexOf('.');
      var integerPart = '';
      var decimalPart = '';
      if (dotIndex === -1) {
        integerPart = cleaned;
      } else {
        integerPart = cleaned.slice(0, dotIndex);
        decimalPart = cleaned.slice(dotIndex + 1).replace(/\./g, '');
      }
      integerPart = integerPart.slice(0, 9);
      decimalPart = decimalPart.slice(0, 2);
      var nextValue = integerPart;
      if (dotIndex !== -1) {
        nextValue = "".concat(integerPart, ".").concat(decimalPart);
      }
      this.formData.items.mall_decoration.budget = nextValue;
    },
    getCompanyList: function getCompanyList(val) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getCustomerList({
                page_size: 200,
                name: val || '',
                is_delete: 0
              });
            case 2:
              res = _context2.sent;
              _this3.companyList = res.data.list;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    submitForm: function submitForm() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.formData.id) {
            _this4.again();
          } else {
            _this4.add();
          }
        }
      });
    },
    add: function add() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return createProjectDelivery(_this5.formData);
            case 2:
              res = _context3.sent;
              _this5.$message.success('提交成功');
              _this5.$emit('close');
              _this5.$emit('update:visible', false);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    again: function again() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return launchedAgain(_this6.formData);
            case 2:
              res = _context4.sent;
              _this6.$message.success('提交成功');
              _this6.$emit('close');
              _this6.$emit('update:visible', false);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    viewDetail: function viewDetail() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res, defaults, company;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return getProjectDeliveryDetail({
                id: _this7.id
              });
            case 2:
              res = _context5.sent;
              _this7.formData = res.data;
              if (_this7.formData.items && _this7.formData.items.mall_decoration) {
                defaults = {
                  hasDiscount: '',
                  discount: ''
                };
                _this7.formData.items.mall_decoration = _objectSpread(_objectSpread({}, defaults), _this7.formData.items.mall_decoration);
              }
              company = {
                id: res.data.customer_id,
                company_name: res.data.customer_name
              };
              _this7.companyList.push(company);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    handleApprove: function handleApprove() {
      var _this8 = this;
      this.userList = this.$store.state.user.sellUsersList;
      this.approveDialogVisible = true;
      this.$nextTick(function () {
        _this8.$refs.approveForm.clearValidate();
      });
    },
    confirmApprove: function confirmApprove() {
      var _this9 = this;
      this.$refs.approveForm.validate(function (valid) {
        if (valid) {
          _this9.approve(1);
        }
      });
    },
    handleReject: function handleReject() {
      var _this10 = this;
      this.rejectDialogVisible = true;
      this.$nextTick(function () {
        _this10.$refs.rejectForm.clearValidate();
      });
    },
    confirmReject: function confirmReject() {
      var _this11 = this;
      this.$refs.rejectForm.validate(function (valid) {
        if (valid) {
          _this11.approve(0);
        }
      });
    },
    approve: function approve(status) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var data, res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              data = {};
              if (status == 1) {
                data = _objectSpread(_objectSpread({}, _this12.formData), _this12.approveFormData);
              } else {
                data = _objectSpread(_objectSpread({}, _this12.formData), _this12.rejectFormData);
              }
              _context6.next = 4;
              return auditProjectDelivery(data);
            case 4:
              res = _context6.sent;
              _this12.$message.success(status == 1 ? '审批通过' : '审批驳回');
              _this12.approveDialogVisible = false;
              _this12.rejectDialogVisible = false;
              _this12.$emit('close');
              _this12.$emit('update:visible', false);
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getLog: function getLog() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var res;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return getProjectDeliveryLog(_this13.logSearchForm);
            case 2:
              res = _context7.sent;
              _this13.logList = res.data;
              _this13.logPages = res.pages;
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === '2') {
        this.handlePageChange(1);
      }
    },
    handlePageChange: function handlePageChange(page) {
      this.logSearchForm.page = page;
      this.getLog();
    },
    sizeChange: function sizeChange(size) {
      this.logSearchForm.pageSize = size;
      this.logSearchForm.page = 1;
      this.getLog();
    }
  }
};